import { useMemo } from 'react';

export type TLocalize = (key: string, fallback: string) => string;

export const useLocalize = (languageData: Record<string, string>): TLocalize => {
    return useMemo(
        () => (key: string, fallback: string) => {
            return languageData[key] != '' && languageData[key] ? languageData[key] : fallback
        },
        [languageData],
    );
};
